import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  dataRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

const specialPagesCollectionRN =
  'specialPages.collections.specialPagesCollection';

export default function createContainer(ChildContainer) {
  class SpecialPagesViewContainer extends Component {
    constructor(props) {
      super(props);
      this.props.dataRequest();
    }

    render() {
      return <ChildContainer {...this.props} />;
    }
  }

  SpecialPagesViewContainer.propTypes = {
    // CONNECT DISPATCH
    dataRequest: PropTypes.func.isRequired
  };

  const mapStateToProps = (state, props) => ({
    requestState: selectRequestsStateById(
      state,
      specialPagesCollectionRN,
      props.match.params.id
    ),
    item: selectItemById(state, specialPagesCollectionRN, props.match.params.id)
  });

  const mapDispatchToProps = (dispatch, props) => ({
    dataRequest: () =>
      dispatch(dataRequest(specialPagesCollectionRN, props.match.params.id))
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(SpecialPagesViewContainer);
}



// WEBPACK FOOTER //
// ./src/components/SpecialPages/containers/SpecialPagesViewContainer/SpecialPagesViewContainer.js